import { useCredentialingTranslation } from '../../../../ui/hooks';
import { TextCell } from '@juvare/common-data-table-ui/DataTable';
import SafetyCheckIcon from '@juvare/common-web-ui/icons/SafetyCheck';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import AddModeratorIcon from '@mui/icons-material/AddModerator';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { Stack, Typography } from '@mui/material';
import React from 'react';
export const iconMap = {
    success: React.createElement(CheckCircleIcon, { htmlColor: themeColors.accent.green.base }),
    failed: React.createElement(CancelIcon, { htmlColor: themeColors.accent.red.base }),
    expired: React.createElement(RemoveCircleIcon, { htmlColor: themeColors.accent.grey.base }),
    unknown: React.createElement(ReportProblemIcon, { htmlColor: themeColors.accent.orange.base }),
    attention: React.createElement(ErrorIcon, { htmlColor: themeColors.accent.blue.base }),
    processing: React.createElement(SafetyCheckIcon, { htmlColor: themeColors.accent.blue.base }),
    ready: React.createElement(AddModeratorIcon, { htmlColor: themeColors.accent.grey.base }),
};
const licenseStatusIconMap = {
    cvoExpired: iconMap.expired,
    expired: iconMap.expired,
    inactive: iconMap.failed,
    missingFields: iconMap.attention,
    multipleMatchesFound: iconMap.failed,
    noMatchFound: iconMap.failed,
    notChecked: iconMap.attention,
    notVerified: iconMap.failed,
    outOfState: iconMap.failed,
    pending: iconMap.processing,
    readyToVerify: iconMap.ready,
    verified: iconMap.success,
    verifiedExpirationUpdated: iconMap.success,
    unknown: iconMap.unknown,
};
export const StatusCheckCell = ({ status = 'unknown' }) => {
    const { t } = useCredentialingTranslation();
    const icon = licenseStatusIconMap[status];
    return (React.createElement(TextCell, null,
        React.createElement(Stack, { alignItems: 'center', direction: 'row', gap: 1 },
            icon,
            React.createElement(Typography, { color: themeColors.text.main, variant: 'inherit' }, t(`licenseStatuses.${status}`)))));
};
